import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-up",
  "use": "arrow-angle-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-up\"><path d=\"M4.207 9.74c-.536-.537.138-1.086.138-1.086L7.999 5l3.657 3.657c0-.003.638.578.134 1.082-.504.504-1.08-.138-1.08-.131L8 6.896 5.293 9.6c0 .007-.55.674-1.086.138z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol